import axios from 'axios';
import qs from 'qs';
import store from '../store';
import {
    CreatePriceOfferResponseEntity,
    DeliveryMethodTypes,
    PromotionPackageCustomerContactEntity,
    PromotionPackageEntity,
    PromotionPackageInfoJson,
    PromotionPackageResponseCodes,
    PromotionPackageResponseEntity,
    PromotionPackageSimpleResponseEntity,
    ValidatePromotionPackageResponseEntity,
} from '../types/promotion';

export const USE_MOCK = false;

const PROD_BASE_URL = 'https://interfaceserviceapi.y-it.co.il/PromotionPackageService/PromotionPackageService.svc';
const DEV_BASE_URL = 'https://interfaceserviceapidev.y-it.co.il/PromotionPackageService/PromotionPackageService.svc';
const STAGE_BASE_URL = 'https://interfaceserviceapi.ebstage.y-it.co.il/PromotionPackageService/PromotionPackageService.svc';

const BASE_URLS: Record<ReturnType<typeof store.getState>['main']['env'], string> = {
    DEV: DEV_BASE_URL,
    STAGE: STAGE_BASE_URL,
    PROD: PROD_BASE_URL,
};

const getBaseUrl = () => BASE_URLS[store.getState().main.env] ?? PROD_BASE_URL;

const postForm = <T>(endpoint: string, payload: Record<string, string>) =>
    axios.post<T>(`${getBaseUrl()}/${endpoint}`, qs.stringify(payload), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

const MOCK_DELAY_MS = 700;
const mockDelay = <T>(value: T): Promise<T> => new Promise((resolve) => setTimeout(() => resolve(value), MOCK_DELAY_MS));

const logApiResponse = (endpoint: string, data: object) => {
    const { flowToken, contactToken, ...safeData } = data as Record<string, unknown> & { flowToken?: string; contactToken?: string };
    console.log(`[promotionApi] ${endpoint} response:`, safeData);
};

const MOCK_PACKAGE: PromotionPackageEntity = {
    promotionPackageID: 1,
    name: 'שדרוג ל-YIT Pro',
    remarks: 'חבילת השדרוג המקצועית שלנו, עם מודול אוטומציות, אחסון מורחב וליווי הטמעה מלא. מותאמת אישית לארגון שלך.',
    description: 'שדרוג ל-YIT Pro — עד 15% הנחה',
    expiryDate: '2026-07-31',
    validityOffer: 21,
    timeScheduleID: 0,
    totalPrice: 1259,
    totalPriceWithDiscount: 1070,
    priceOfferDiscountReasonID: null,
    infoJson: '',
    isActive: true,
    createdDate: '2026-06-01',
    modifiedDate: '2026-06-01',
    rowGuid: 'mock-package-guid',
    estates: [
        {
            promotionPackageID: 1,
            estateTypeID: 1,
            estateTypeName: 'מודול קצין בטיחות עמדה ראשית',
            catalogNumber: 'SAFETY-01',
            amount: 1,
            percentageDiscount: 0,
            price: 0,
            remarks: '',
            startDateByMonths: 0,
            endDateByMonths: 0,
            isActive: true,
            createdDate: '2026-06-01',
            modifiedDate: '2026-06-01',
            rowGuid: 'mock-estate-1',
        },
        {
            promotionPackageID: 1,
            estateTypeID: 2,
            estateTypeName: 'RMS - Basic',
            catalogNumber: 'RMS-BASIC',
            amount: 1,
            percentageDiscount: 100,
            price: 0,
            remarks: '',
            startDateByMonths: 0,
            endDateByMonths: 3,
            isActive: true,
            createdDate: '2026-06-01',
            modifiedDate: '2026-06-01',
            rowGuid: 'mock-estate-2',
        },
        {
            promotionPackageID: 1,
            estateTypeID: 3,
            estateTypeName: 'תוסף טפסים - RMS דיגיטליים',
            catalogNumber: 'RMS-FORMS',
            amount: 1,
            percentageDiscount: 100,
            price: 0,
            remarks: '',
            startDateByMonths: 0,
            endDateByMonths: 3,
            isActive: true,
            createdDate: '2026-06-01',
            modifiedDate: '2026-06-01',
            rowGuid: 'mock-estate-3',
        },
        {
            promotionPackageID: 1,
            estateTypeID: 4,
            estateTypeName: 'תוסף מיקומי רכבים - RMS',
            catalogNumber: 'RMS-GPS',
            amount: 1,
            percentageDiscount: 20,
            price: 0,
            remarks: '',
            startDateByMonths: 0,
            endDateByMonths: 12,
            isActive: true,
            createdDate: '2026-06-01',
            modifiedDate: '2026-06-01',
            rowGuid: 'mock-estate-4',
        },
        {
            promotionPackageID: 1,
            estateTypeID: 5,
            estateTypeName: 'דיווח טכוגרף (MyDay)',
            catalogNumber: 'MYDAY-TACHO',
            amount: 1,
            percentageDiscount: 20,
            price: 0,
            remarks: '',
            startDateByMonths: 0,
            endDateByMonths: 12,
            isActive: true,
            createdDate: '2026-06-01',
            modifiedDate: '2026-06-01',
            rowGuid: 'mock-estate-5',
        },
    ],
};

const MOCK_INFO_JSON: PromotionPackageInfoJson = {
    "promoTitle": 'באנדל קציני הבטיחות',
    "promoHeader": 'מבצע מיוחד ללקוחות YIT',
    "description": 'שפר את יכולות קצין הבטיחות שלך',
    "notes": ['חיסכון משמעותי בזמן', 'גישה למאגר הנהגים\רכבים בלחיצת כפתור', 'שליטה ובקרה בכל זמן נתון', 'עבודה מכל מקום'],
};

// const MOCK_INFO_JSON: PromotionPackageInfoJson = {
//     promoTitle: 'שדרוג ל-YIT Pro — עד 15% הנחה',
//     promoHeader: 'מבצע מיוחד ללקוחות YIT',
//     description: 'חבילת השדרוג המקצועית שלנו, עם מודול אוטומציות, אחסון מורחב וליווי הטמעה מלא. מותאמת אישית לארגון שלך.',
//     notes: ['ליווי הטמעה והדרכה אישית', 'מודול אוטומציות שחוסך שעות עבודה', 'שקיפות מלאה — ללא עלויות נסתרות'],
// };

const MOCK_CONTACTS: PromotionPackageCustomerContactEntity[] = [
    { customerID: 1, customerName: 'טכנולוגיות אלפא בע״מ', customerToken: 'mock-customer-1', contactID: 10, contactName: 'ישראל ישראלי', contactEmail: 'israel@alpha-tech.co.il', contactToken: 'mock-contact-1' },
    { customerID: 2, customerName: 'מרפאות בטא רשת בע״מ', customerToken: 'mock-customer-2', contactID: 11, contactName: 'דנה כהן', contactEmail: 'dana@beta-clinics.co.il', contactToken: 'mock-contact-2' },
];

export const validatePromotionPackage = async (promotionPackageToken: string): Promise<ValidatePromotionPackageResponseEntity> => {
    if (USE_MOCK) {
        return mockDelay({
            response: PromotionPackageResponseCodes.Success,
            message: 'OK',
            flowToken: 'mock-flow-token',
            infoJson: JSON.stringify(MOCK_INFO_JSON),
        });
    }
    const { data } = await postForm<ValidatePromotionPackageResponseEntity>('ValidatePromotionPackage', { promotionPackageToken });
    logApiResponse('ValidatePromotionPackage', data);
    return data;
};

const MOCK_UNKNOWN_CONTACT_SUFFIX = '4444';

export const send2FaCode = async (flowToken: string, phoneNumber: string): Promise<PromotionPackageSimpleResponseEntity> => {
    if (USE_MOCK) {
        if (phoneNumber.replace(/\D/g, '').endsWith(MOCK_UNKNOWN_CONTACT_SUFFIX)) {
            return mockDelay({
                response: PromotionPackageResponseCodes.ContactWasNotFound,
                message: 'Contact not found',
                flowToken,
                twoFaExpirationByMinutes: 5
            });
        }
        return mockDelay({
            response: PromotionPackageResponseCodes.Success,
            message: 'OK',
            flowToken,
            twoFaExpirationByMinutes: 5
        });
    }
    const { data } = await postForm<PromotionPackageSimpleResponseEntity>('Send2FaCodeToContactPhoneNumber', { flowToken, phoneNumber });
    logApiResponse('Send2FaCodeToContactPhoneNumber', data);
    return data;
};

export const validate2FaCode = async (flowToken: string, code: string): Promise<PromotionPackageResponseEntity> => {
    if (USE_MOCK) {
        return mockDelay({
            response: PromotionPackageResponseCodes.Success,
            message: 'OK',
            flowToken,
            numberOfTriesLeft: 5,
            customersContacts: MOCK_CONTACTS,
            promotionPackage: MOCK_PACKAGE,
        });
    }
    const { data } = await postForm<PromotionPackageResponseEntity>('Validate2FaCode', { flowToken, code });
    logApiResponse('Validate2FaCode', data);
    return data;
};

export const createPriceOffer = async (flowToken: string, contactToken: string): Promise<CreatePriceOfferResponseEntity> => {
    if (USE_MOCK) {
        return mockDelay({
            response: PromotionPackageResponseCodes.Success,
            message: 'OK',
            flowToken,
            deliveryMethodId: String(DeliveryMethodTypes.Sms),
            addressingId: 'SR-2026-04817',
        });
    }
    const { data } = await postForm<CreatePriceOfferResponseEntity>('CreatePriceOffer', { flowToken, contactToken });
    logApiResponse('CreatePriceOffer', data);
    return data;
};
